import type * as z from 'zod';

import { connectedAppQuerySchema } from './connected-app-query-schema';

export const connectedAppMutationSchema = connectedAppQuerySchema.omit({
  legal_entity: true,
  brand: true,
  created_at: true,
  updated_at: true,
  api_keys: true,
});

export type ConnectedAppMutationSchema = z.infer<typeof connectedAppMutationSchema>;

export const connectedAppCreateSchema = connectedAppMutationSchema.omit({
  id: true,
});

export type ConnectedAppCreateSchema = z.infer<typeof connectedAppCreateSchema>;
